import * as THREE from 'three';
import { PuzzleElement } from './PuzzleElement';

export class TimedDoor extends PuzzleElement {
  private doorMesh: THREE.Mesh;
  private isOpen: boolean = false;
  private timer: number = 0;
  private openDuration: number;
  private closedY: number;
  private openY: number;
  private triggerDistance: number;
  private triggered: boolean = false;
  private doorHeight: number = 5;
  private doorWidth: number = 3;
  
  constructor(
    position: THREE.Vector3, 
    openDuration: number = 3, 
    triggerDistance: number = 3,
    width: number = 3
  ) {
    super(position);
    this.openDuration = openDuration;
    this.triggerDistance = triggerDistance;
    this.doorWidth = width;
    this.closedY = position.y;
    this.openY = position.y + this.doorHeight;
    this.doorMesh = this.mesh as THREE.Mesh;
    
    // Update geometry with correct width
    (this.mesh as THREE.Mesh).geometry.dispose();
    (this.mesh as THREE.Mesh).geometry = new THREE.BoxGeometry(width, this.doorHeight, 0.5);
  }
  
  protected createMesh(): THREE.Mesh {
    const geometry = new THREE.BoxGeometry(this.doorWidth, this.doorHeight, 0.5);
    const material = new THREE.MeshStandardMaterial({ 
      color: 0x8b4513,
      roughness: 0.8,
      metalness: 0.2
    });
    
    const mesh = new THREE.Mesh(geometry, material);
    mesh.castShadow = true;
    mesh.receiveShadow = true;
    
    return mesh;
  }
  
  public update(deltaTime: number, playerPosition: THREE.Vector3): void {
    const distance = this.position.clone().setY(playerPosition.y).distanceTo(
      playerPosition.clone().setY(playerPosition.y)
    );
    
    // Check if player is near the trigger zone
    if (!this.triggered && distance < this.triggerDistance) {
      this.trigger();
    }
    
    // Update door position
    if (this.isOpen) {
      this.timer -= deltaTime;
      
      if (this.timer <= 0) {
        this.isOpen = false;
        this.triggered = false; // Can be retriggered
      }
    }
    
    // Animate door
    const targetY = this.isOpen ? this.openY : this.closedY;
    this.mesh.position.y += (targetY - this.mesh.position.y) * 0.1;
  }
  
  public trigger(): void {
    if (!this.triggered) {
      this.triggered = true;
      this.isOpen = true;
      this.timer = this.openDuration;
    }
  }
  
  public isBlocking(): boolean {
    return !this.isOpen && this.mesh.position.y < this.closedY + 0.5;
  }
  
  public getCollisionBox(): THREE.Box3 | null {
    if (this.isBlocking()) {
      return new THREE.Box3().setFromObject(this.mesh);
    }
    return null;
  }
}
